import React from 'react'
import OrcamentoListPageContainer from './MarcadorListPageContainer'

export class MarcadorListPage extends React.Component {
  render() {
    return <OrcamentoListPageContainer {...this.props} />
  }
}
